module.exports = __webpack_public_path__ + "static/img/sbanner3.d0aa55e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sbanner3.png
// module id = K+M9
// module chunks = 1